import { actionType } from '../../../redux/modules/orientationwrapper';

// Show Unsaved Changes Modal
export default function setOrientationName(orientation) {
  return dispatch => dispatch({ type: actionType.SET_ORIENTATION_DATA, data: orientation });
}
